import { useSyncExternalStore } from 'react';
import {
  getApiFeedbackState,
  subscribeToApiFeedback
} from '../../services/api-feedback';

const useApiFeedback = () =>
  useSyncExternalStore(subscribeToApiFeedback, getApiFeedbackState, getApiFeedbackState);

export default useApiFeedback;
